// Contexto + modal de Administração.
// A Administração deixou de ser uma tela própria e passa a abrir como modal
// sobre o sistema, acionada pelo item de navegação.

import React, { createContext, useContext, useState, useCallback } from 'react';
import { Modal } from './ui/Modal';
import AdminPage from '../pages/AdminPage';

interface AdminModalContextValue {
  isOpen: boolean;
  openAdmin: () => void;
  closeAdmin: () => void;
}

const AdminModalContext = createContext<AdminModalContextValue>({
  isOpen: false,
  openAdmin: () => {},
  closeAdmin: () => {},
});

export const useAdminModal = (): AdminModalContextValue => useContext(AdminModalContext);

export const AdminModalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const openAdmin = useCallback(() => setIsOpen(true), []);
  const closeAdmin = useCallback(() => setIsOpen(false), []);

  return (
    <AdminModalContext.Provider value={{ isOpen, openAdmin, closeAdmin }}>
      {children}
      <Modal isOpen={isOpen} onClose={closeAdmin} title="Administração" size="2xl" data-testid="admin-modal">
        {isOpen && <AdminPage embedded />}
      </Modal>
    </AdminModalContext.Provider>
  );
};
